import type { ElementType, HTMLAttributes, ReactNode, Ref } from "react"

import { gapScale } from "@/components/ui/layout"
import { tv, type VariantProps } from "@/lib/utils/tv"

const row = tv({
  base: "flex",
  variants: {
    gap: gapScale,
    align: { start: "items-start", center: "items-center", end: "items-end", baseline: "items-baseline", stretch: "items-stretch" },
    justify: { start: "justify-start", center: "justify-center", between: "justify-between" },
    wrap: { true: "flex-wrap" },
  },
  defaultVariants: { gap: "200", align: "center", justify: "start" },
})

interface RowProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof row> {
  ref?: Ref<HTMLElement>
  as?: ElementType
  children?: ReactNode
}

export const Row = ({ gap, align, justify, wrap, as, className, children, ...rest }: RowProps) => {
  const Element = as ?? "div"
  return (
    <Element className={row({ gap, align, justify, wrap, className })} {...rest}>
      {children}
    </Element>
  )
}
